<template>
  <div class="sub_Navi">
    <ul>
      <li><a class="back" @click="closeModal">뒤로</a></li>
      <li>
        <h1>{{ $t('mypage.connectExAPI') }}</h1>
      </li>
      <li class="linkBox">
        <!-- <router-link to="/user" class="close" >닫기</router-link> -->
      </li>
    </ul>
  </div>
  <!--subPage -->
  <div>
    <div class="subPage_container" :class="[{ isModalOpen: clickApi }, { isModalOpen: agreeApi }]">
      <!--연동거래소 리스트-->
      <div class="api_inner">
        <h3>{{ $t('mypage.connectEx') }}</h3>
        <ul>
          <li v-for="(item, i) in connectedList" :key="i">
            <div>
              <i class="exc_img"><img :src=getImagePath(item.exchange) /></i>
              <span class="exc_name">{{ item.exchange }}</span>
            </div>
            <div>
              <span class="date">2024.02.17</span>
              <a @click="changeAgreeState(item.exchange); changeEdit({ state: true })"
                class="link_on">API수정</a><!--연동 활성화여부: link_on, link_off 클래스 추가-->
              <a class="link_delete modal_open" @click="changeDeleteState((item.exchange))" data-modal="100">삭제</a>
            </div>
          </li>
        </ul>
        <div class="nodata3" v-if="connectedList.length == 0">{{ $t('mypage.noConnectAPI') }}</div>
      </div>

      <!--미연동 거래소 리스트-->
      <div class="api_inner line">
        <h3>{{ $t('mypage.notConnectEx') }}</h3>
        <ul>
          <li v-for="(item, i) in notConnectedList" :key="i">
            <div>
              <i class="exc_img"><img :src=getImagePath(item.exchange)></i>
              <span class="exc_name">{{ item.exchange }}</span>
            </div>
            <div>
              <a class="link_regi" @click="changeAgreeState(item.exchange)">연동하기</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--//subPage_container :End -->
    <!--//subPage :End -->

    <!-- modal popup-->
    <div class="modalBackColor"></div>

    <!-- modal center 팝업 -->
    <div class="modal_pop_small modal_no100" v-if="deleteApi == true" data-modal="100">
      <div class="smallPop popup_block">
        <div class="pop_title">
          <p>{{ $t('mypage.delete') }}</p>
          <span @click="closeModal" class="pop_close">창닫기</span>
        </div>
        <div class="con_wrap">
          <P>{{ $t('mypage.deleteAPI') }}</P>
        </div>
        <div class="btn_bottom">
          <a @click="closeModal" class="btn_gray">{{ $t('mypage.no') }}</a>
          <a @click="closeModal; deleteConfrim(targetEx)" class="">{{ $t('mypage.yes') }}</a>
        </div>
      </div>
    </div>
    <!-- //modal center 팝업:End -->

    <AgreeApi v-if="agreeApi" />
    <ConnectApi v-if="clickApi" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import AgreeApi from "@/components/modal/AgreeApi.vue";
import ConnectApi from "@/components/modal/ConnectApi.vue";
import { getConnectedApiFunc, deleteApiFunc } from "@/api/regApi";
import { popupControll } from "@/utils/modalText";
export default {
  name: "SettinApi",
  components: {
    AgreeApi,
    ConnectApi,
  },
  data() {
    return {
      connectedList: [],
      notConnectedList: [],
      targetEx: "",
      userId: localStorage.getItem("userId")
    }
  },
  computed: {
    ...mapState("user", ["agreeApi", "clickApi", "deleteApi"]),
    ...mapState("setApi", ["regEx", "edit"]),
  },
  created() {
    getConnectedApiFunc().then((res) => {
      // // console.log(res);
      let data = res.data
      if (data.isSuccess == true) {
        data.data.find((el) => {
          if (el.status == true) {
            this.connectedList.push(el)
          } else {
            this.notConnectedList.push(el)
          }
        })
      }
      // // console.log('연결 거래소', this.connectedList);
      // // console.log('미연결 거래소', this.notConnectedList);
    })
  },
  methods: {
    ...mapMutations("user", ["changeApi", "changeAgree", "changeDelete"]),
    ...mapMutations("setApi", ['setEx', "changeEdit"]),
    // deleteApiFunc,
    openApiState() {
      this.changeApi({ state: true });
    },
    changeAgreeState(ex) {
      this.changeAgree({ state: true });
      this.setEx({ exchange: ex })
    },
    changeDeleteState(ex) {
      this.changeDelete({ state: true });
      this.setEx({ exchange: ex })
      this.targetEx = ex;
    },
    closeModal() {
      if (this.clickApi == true) {
        this.changeApi({ state: false });
        this.changeEdit({ state: false });
      } else if (this.agreeApi == true) {
        this.changeAgree({ state: false });
        this.changeEdit({ state: false });
      } else if (this.deleteApi == true) {
        this.changeDelete({ state: false });
      } else {
        this.$router.push("/user");
      }
    },
    getImagePath(exchange) {
      let lowerEx = exchange.toLowerCase();
      return require("@/assets/images/exchange/ec_" + lowerEx + ".png")
    },
    deleteConfrim(ex) {
      // // console.log('ex', ex);
      deleteApiFunc(ex).then((res) => {
        // // console.log(res);
        if (res.data.isSuccess == true) {
          this.connectedList = [];
          this.notConnectedList = [];
          // alert('성공');
          popupControll(this.$t('mypage.successDelete'))
          getConnectedApiFunc().then((res) => {
            // // console.log(res);
            let data = res.data
            if (data.isSuccess == true) {
              data.data.find((el) => {
                if (el.status == true) {
                  this.connectedList.push(el)
                } else {
                  this.notConnectedList.push(el)
                }
              })
              this.changeDelete({ state: false });
            }
            // // console.log('연결 거래소',this.connectedList);
            // // console.log('미연결 거래소',this.notConnectedList);
          })
        } else {
          popupControll(this.$t('mypage.failDelete'))
          this.changeDelete({ state: false });
        }
      })
    }
  },
};
</script>

<style scoped>
/* api 페이지만 padding-top 삭제 */
.subPage_container {
  padding: 0;
}


/* 마이-설정-api 거래소 페이지-삭제모달 */
.modal_pop_small {
  display: block;
  background: rgba(0, 0, 0, 0.8);
}
</style>